var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('v-divider', {
    staticClass: "primary border-2"
  }), _c('v-row', {
    staticClass: "ma-0",
    attrs: {
      "no-gutters": ""
    }
  }, _vm._l(_vm.items, function (item, index) {
    var _item$cols, _item$order, _item$orderLg;
    return _c('v-col', {
      key: index,
      staticClass: "d-flex flex-column",
      attrs: {
        "cols": "12",
        "lg": (_item$cols = item === null || item === void 0 ? void 0 : item.cols) !== null && _item$cols !== void 0 ? _item$cols : _vm.defaultCols,
        "order": (_item$order = item === null || item === void 0 ? void 0 : item.order) !== null && _item$order !== void 0 ? _item$order : undefined,
        "order-lg": (_item$orderLg = item === null || item === void 0 ? void 0 : item.orderLg) !== null && _item$orderLg !== void 0 ? _item$orderLg : undefined
      }
    }, [_vm.isArray(item) ? _vm._l(item, function (child) {
      return _c('vertical-table-row', _vm._b({
        key: child.term
      }, 'vertical-table-row', child, false), [false ? void 0 : child.data ? [_vm._v(" " + _vm._s(child.data) + " ")] : _vm.$slots[child.term] ? _vm._t(child.term) : child.node ? _c('v-node', {
        attrs: {
          "node": child.node
        }
      }) : _vm._e()], 2);
    }) : [_c('vertical-table-row', _vm._b({}, 'vertical-table-row', item, false), [false ? void 0 : item.data ? [_vm._v(" " + _vm._s(item.data) + " ")] : _vm.$slots[item.term] ? _vm._t(item.term) : item.node ? _c('v-node', {
      attrs: {
        "node": item.node
      }
    }) : _vm._e()], 2)]], 2);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }